var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge fw-bold px-3 py-2",class:_vm.badgeClass},[_vm._v(" "+_vm._s(_vm._f("formatCampaignStatus")(_vm.status))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }